import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import { CommonApplicationActionTypes } from './types'
import { AppConfig } from './../../appConfig';
import { fetchSuccessModels, fetchSuccessInfotaiments, fetchSuccessCountries, fetchSuccessImporterSettings } from './actions';
import { callApi } from '../../utils/api';

function* handleFetchModels() {
	try {
		const res: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.ModelFamilyModel[] = yield call(callApi, 'get', 'api/Filter/GetModels?importerBid=' + AppConfig.GlobalSetting.Bid + '&culture=' + AppConfig.GlobalSetting.Culture);
		yield put(fetchSuccessModels(res))
	}
	catch (err) {
		console.error(err);
	}
}

function* handleFetchInfotaiments(action: any) {
	try {
		const res: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.InfotaimentModel[] = yield call(callApi, 'get', 'api/Filter/GetInfotaiments?importerBid=' + AppConfig.GlobalSetting.Bid + '&culture=' + AppConfig.GlobalSetting.Culture);
		yield put(fetchSuccessInfotaiments(res))
	}
	catch (err) {
		console.error(err);
	}
}

function* handleFetchCountries() {
	try {
		const res: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.CodeListItemModel[] = yield call(callApi, 'get', 'api/Filter/GetCountries?importerBid=' + AppConfig.GlobalSetting.Bid + '&culture=' + AppConfig.GlobalSetting.Culture);
		yield put(fetchSuccessCountries(res))
	}
	catch (err) {
		console.error(err);
	}
}

function* handleFetchImporterSettings() {
	try {
		const res: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.ImporterSettingsModel = yield call(callApi, 'get', 'api/ImporterSettings/Get?importerBid=' + AppConfig.GlobalSetting.Bid + '&culture=' + AppConfig.GlobalSetting.Culture);
		yield put(fetchSuccessImporterSettings(res));
	}
	catch (err) {
		console.error(err);
	}
}

function* watchCommonFetchRequestModels() {
	yield takeEvery(CommonApplicationActionTypes.FETCH_REQUEST_Models, handleFetchModels);
}

function* watchCommonFetchRequestInfotaiments() {
	yield takeEvery(CommonApplicationActionTypes.FETCH_REQUEST_Infotaiments, handleFetchInfotaiments);
}

function* watchCommonFetchRequestCountries() {
	yield takeEvery(CommonApplicationActionTypes.FETCH_REQUEST_Countries, handleFetchCountries);
}

function* watchCommonFetchRequestImporterSettings() {
	yield takeEvery(CommonApplicationActionTypes.FETCH_REQUEST_ImporterSettings, handleFetchImporterSettings);
}

function* commonApplicationSaga() {
	yield all([fork(watchCommonFetchRequestModels), fork(watchCommonFetchRequestInfotaiments), fork(watchCommonFetchRequestCountries), fork(watchCommonFetchRequestImporterSettings) ]);
}

export default commonApplicationSaga
